import { useLocation } from "react-router";
import type { IconType } from "react-icons";
import type { ButtonProps } from "@chakra-ui/react";

import { MenuItemButton } from "@shared/ui/menu-item-button";

interface Props {
  id: string;
  name: string;
  path: string;
  icon: IconType;
  colorPalette?: string;
  buttonProps?: ButtonProps;
  notificationText?: string | number;
}

export const DestinationButton: React.FC<Props> = ({
  id,
  name,
  icon,
  path,
  notificationText,
  colorPalette = "teal",
  buttonProps,
}) => {
  const isActive = useLocation().pathname === path;

  return (
    <MenuItemButton
      id={id}
      to={path}
      icon={icon}
      label={name}
      active={isActive}
      buttonProps={buttonProps}
      colorPalette={colorPalette}
      notificationText={notificationText}
    />
  );
};
